import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import { h5Styles } from '~typography';
import commerceTheme from '../../styles/commerceTheme';
var ItemTitle = styled.span.attrs(function () {
  return {
    colorValue: 'dark'
  };
}).withConfig({
  displayName: "ItemTitle",
  componentId: "fcvetg-0"
})(["", " font-family:", ";font-size:", ";margin-bottom:", ";"], h5Styles, function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'commerce.adsBanner.fontFamily', commerceTheme.commerce.adsBanner.fontFamily);
}, rem(14), rem(2));
export default ItemTitle;